

















































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { IAuthForm } from '@/store/modules/auth/namespace';

export default Vue.extend({
    name: 'AuthForm',
    mixins: [validationMixin],
    validations: {
        auth: {
            login: {
                required,
            },
            password: {
                required,
            }
        },
    },
    computed: {
        ...mapGetters('auth', {
            activeFormRequest: 'getActiveFormRequest',
            failedFormRequest: 'getFailedFormRequest',
        }),
    },
    data() {
        return {
            auth: {
                login: '',
                password: '',
            } as IAuthForm
        };
    },
    methods: {
        ...mapActions('auth', {
            resetForm: 'resetForm',
            loginAction: 'login'
        }),
        login() {
            this.$v.auth.$touch();
            if (this.$v.auth.$anyError) {
                return;
            }
            this.loginAction(this.auth).then(res => {
                if (res === true) {
                    this.$router.push('/');
                } else {
                    console.log('login error');
                }
            });
        },
        validateState(name: string): boolean | null {
            const valResult = this.$v.auth[name];
            if (valResult !== undefined) {
                return valResult.$dirty ? !valResult.$error : null;
            } else {
                return null;
            }
        },
    }
});
